import {FC} from 'react';

interface CheckGuaranteeProps {}

export const CheckGuarantee: FC<CheckGuaranteeProps> = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_770_41812)">
        <path
          d="M5.71436 11.4285L8.64293 13.7714C8.72158 13.8361 8.81367 13.8826 8.91252 13.9073C9.01137 13.932 9.11448 13.9344 9.21435 13.9142C9.31519 13.8953 9.41076 13.8549 9.49458 13.7957C9.57839 13.7366 9.64848 13.6601 9.70007 13.5714L14.2858 5.71423"
          stroke="black"
          strokeWidth="1.42857"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.0001 19.2857C15.1284 19.2857 19.2858 15.1283 19.2858 9.99995C19.2858 4.87159 15.1284 0.714233 10.0001 0.714233C4.87171 0.714233 0.714355 4.87159 0.714355 9.99995C0.714355 15.1283 4.87171 19.2857 10.0001 19.2857Z"
          stroke="black"
          strokeWidth="1.42857"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_770_41812">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
